import {Fragment} from 'react';

import {NotificationService as Service} from './NotificationService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../shared/language';

export const List = () => {
  const {t} = useTranslation();

  const typeIn = 1;
  const header = t('common.notificationManagement');
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'name', header: t('common.notificationTitle'), minWidth: 350, matchMode: 'contains'},
      {field: 'startDate', header: t('common.effectiveFrom'), width: 120, matchMode: 'equals', filterType: 'date', dataType: 'date'},
      {field: 'endDate', header: t('common.effectiveTo'), width: 120, matchMode: 'equals', filterType: 'date', dataType: 'date'},
      {field: 'active', header: t('common.active'), width: 100, matchMode: 'equals', filterType: 'boolean', dataType: 'boolean'},
      {field: 'orders', header: t('common.priority'), width: 120, matchMode: 'contains'}
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      params.type = typeIn;
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {field: 'name', header: t('common.notificationTitle'), required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'htmlContents', header: '', required: true, type: 'CKEditor', className: 'md:col-12'},
      {field: 'startDate', header: t('common.effectiveFrom'), type: 'Calendar', className: 'md:col-3'},
      {field: 'endDate', header: t('common.effectiveTo'), type: 'Calendar', className: 'md:col-3'},
      {field: 'orders', header: t('common.priority'), InputTextProps: {maxLength: 120}, className: 'md:col-3'},
      {field: 'active', header: t('common.active'), type: 'Checkbox', className: 'md:col-6 pt-1'}
    ],
    createItem: (item) => {
      item.type = typeIn;
      return Service.create(item);
    },
    updateItem: (id, item) => {
      item.type = typeIn;
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, clone, reloadLazyData, selectedItems,
    update: (selectedItems) => {
      selectedItems.endDate = new Date(selectedItems.endDate);
      selectedItems.startDate = new Date(selectedItems.startDate);
      update(selectedItems);
    },
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
